module.exports = {
    /** 小程序原始 ID（gh_ 开头），微信内置浏览器 H5 用开放标签打开小程序；可被路由参数 mpGh 覆盖 */
    wechatMiniProgramGhUsername: 'gh_c5b2442712a0',
    currentVersion: '202611041613',
    // px 转 rem 缩放的比例
    pxToRemZoom: 7.5,
    /**
     * 判断当前是否处于正式版本
     * 
     * true   ==> 正式环境
     * false  ==> dev
     * -1     ==> local
     */
    isUserCMallOnlineUrl: true
};